export const AZIMUTH_API_URL = process.env.VF_AZIMUTH_API || ''
export const FILER_API_URL = process.env.VF_FILER_API_URL || ''
export const FOUNDRY_URL = process.env.VF_FOUNDRY_URL || ''
export const SWITCHBOARD_URL = process.env.VF_SWITCHBOARD_URL || ''
export const VERSION = 'v0'
export const USER_DATA_BUCKET = process.env.VF_S3_USER_DATA_BUCKET || ''
export const COMPANY_LOGO_URL = `http://${USER_DATA_BUCKET}.s3-us-west-2.amazonaws.com/:orgId/logo.png`
export const WEB_APP_URL = process.env.VF_WEB_APP_URL || ''
export const MARCO_URL = process.env.VF_MARCO_URL || ''
export const COGNITO_PROXY_URL = process.env.VF_COGNITO_PROXY_URL || ''
